// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"df1f2fe4","275":"fd047928","333":"d393b3b2","337":"74d1c930","357":"b0be52e4","389":"c0adb52c","610":"404ec416","640":"8ec50cbc","714":"de292592","769":"6fcde7c0","797":"a59d7f96","967":"8b39f05a"}[chunkId] + ".chunk.js";
};